import React from 'react';
import {useDispatch} from 'react-redux';
import {logout} from '../../slices/auth.slice';
import PinScreen from '../../components/PinScreen';

const PinCode = () => {
    const dispatch = useDispatch();

    const handleSuccess = () => {
        window.location.reload();
    };

    const handleUsePassword = () => {
        dispatch(logout());
        window.location.href = '/login';
    };

    return <PinScreen onSuccess={handleSuccess} onUsePassword={handleUsePassword}/>;
};

export default PinCode;
